import { captureException } from '@playbookux/playbook-web-core';
import client from './client';

export const getProfile = () => client.get('profiles/me')
  .then((response) => response.data)
  .catch((error) => {
    if (error?.response?.status === 401) {
      return;
    }
    captureException('GET_PROFILE_FAILED', error);
  });

export const sendProfileInformation = async (profileId, form, newsletter) => {
  try {
    const data = {
      email: form.email,
      country: form.country,
      first_name: form.firstName,
      last_name: form.lastName,
      birthdate: form.birthdate,
      gender: form.gender,
      race_ethnic_heritage: form.raceEthnicHeritage,
      work_status: form.workStatus,
      annual_household_income: form.annualHouseholdIncome,
      state: form.state,
      job_categories: form.jobCategories,
      payment_method: form.paymentMethod,
      smartphone: form.smartphone,
      computer: form.computer,
      tablet: form.tablet,
      current_position: form.currentPosition,
      paypal_account: form.paypalAccount,
      recruiting_program: form.recruitingProgram,
      education_level: form.educationLevel,
      languages: form.languages,
      last_edition: form.lastEdition,
      phone_number: form.phoneNumber,
      newsletter: newsletter || form.newsletter,
    };
    const response = await client.patch(`profiles/${profileId}`, data);
    return response.data;
  } catch (error) {
    captureException('SEND_PROFILE_INFORMATION_FAILED', error);
    return null;
  }
};
